var _defineMessages;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

var messages = defineMessages((_defineMessages = {
    error: {
        id: 'editor.status.error',
        defaultMessage: 'Error'
    }
}, _defineMessages['error'] = {
    id: 'editor.status.ok',
    defaultMessage: 'Ok'
}, _defineMessages.general = {
    id: 'editor.status.general',
    defaultMessage: 'General'
}, _defineMessages.private = {
    id: 'editor.status.private',
    defaultMessage: 'Private'
}, _defineMessages.new = {
    id: 'editor.status.new',
    defaultMessage: 'New'
}, _defineMessages.draft = {
    id: 'editor.status.draft',
    defaultMessage: 'Draft'
}, _defineMessages.publish = {
    id: 'editor.status.publish',
    defaultMessage: 'Published'
}, _defineMessages.restore = {
    id: 'editor.status.restore',
    defaultMessage: 'Restored'
}, _defineMessages.trash = {
    id: 'editor.status.trash',
    defaultMessage: 'Trash'
}, _defineMessages.failed = {
    id: 'editor.status.failed',
    defaultMessage: 'Failed'
}, _defineMessages.init = {
    id: 'editor.status.init',
    defaultMessage: 'Init'
}, _defineMessages.convert = {
    id: 'editor.status.convert',
    defaultMessage: 'Convert'
}, _defineMessages.done = {
    id: 'editor.status.done',
    defaultMessage: 'Done'
}, _defineMessages));

var ModuleStatusEditorIntl = function (_Component) {
    _inherits(ModuleStatusEditorIntl, _Component);

    function ModuleStatusEditorIntl() {
        _classCallCheck(this, ModuleStatusEditorIntl);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ModuleStatusEditorIntl.prototype.render = function render() {
        var _props = this.props,
            className = _props.className,
            status = _props.status;


        if (!status) {
            status = "error";
        }

        var label = status;

        if (messages[status]) {
            label = this.props.intl.formatMessage(messages[status]);
        }

        return React.createElement(
            'strong',
            { className: className },
            label
        );
    };

    return ModuleStatusEditorIntl;
}(Component);

export default injectIntl(ModuleStatusEditorIntl);